// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"6d6c7f9de41210c132f7","293":"11b3c1e9de6c051b902e","518":"5465fc84e3070db36fba","779":"fa563738f3ff91229ce1"}[chunkId] + ".js";
};